
export default {
    name: 'ContentCardParagraph',
    props: {
        value: {
            required: true,
            default: ''
        }
    },
    mounted() {
        document.querySelectorAll('.accordion h3').forEach(h3 => {
            h3.addEventListener('click', function () {
                // document.querySelectorAll('.accordion-toggle').forEach(toggle => toggle.classList.remove('open'))
                const radioInput = this.previousElementSibling;
                if (radioInput.type === 'radio') {
                    radioInput.classList.toggle('open');
                }
            });
        });
    }
}
